
// import store from '../store'
import * as types from './authentication/mutation-types'


export const createServiceCall = (options) => {
  return ({commit}, payload) => {
    if (options.mainAction) {
      commit(options.mainAction)
    }
    return options.serviceFunction(payload)
        .then((httpResponse) => {
          if (httpResponse.ok) {
            return httpResponse.json()
          } else {
            commit(options.failureAction, httpResponse.statusText)
            const error = new Error(`Http error: ${httpResponse.statusText}`)
            error.response = httpResponse
            throw error
          }
        }).then((parsedResponse) => {
          if (parsedResponse.error) {
            commit(options.failureAction, parsedResponse.error.message)
          } else {
            const successData = options.successDataProperty ? parsedResponse[options.successDataProperty] : parsedResponse;
            commit(options.successAction, successData)
            if (options.successCallback) {
              options.successCallback(parsedResponse)
            }
          }
        }).catch((error) => {
          // toastr['error'](error, 'System error', 3000)
          console.log('Data request failed', error, options);
          // if (error.response && error.response.status === 401) {
          //   commit(types.LOGOUT, payload)
          // }
        })
  }
}
